const createType = (perfix: string) => {
    return {
        REQUEST: perfix + '_REQUEST',
        SUCCESS: perfix + '_SUCCESS',
        FAILED: perfix + '_FAILED'
    };
};

export const MAP_STATION = createType('MAP_STATION');
export const MAP_SYS = createType('MAP_SYS');
export const MAP_COURSE_LIST = createType('MAP_COURSE_LIST');
export const MAP_COURSE_STATUS = createType('MAP_COURSE_STATUS');
export const MAP_USER_SETTING = createType('MAP_USER_SETTING');
export const SET_MAP_USER_SETTING = createType('SET_MAP_USER_SETTING');
export const SET_MAP_IMPORT = createType('SET_MAP_IMPORT');
